// extracted by mini-css-extract-plugin
export default {"popup":"styles_popup__-O3iJ","actions":"styles_actions__c1Pzn","content":"styles_content__9m8Mr"};